import { quickEntries } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div
        className="absolute inset-0 h-full w-full bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20scene%20of%20a%20modern%20outdoor%20music%20festival%20main%20stage%20with%20warm%20amber%20spotlights%20and%20crowd%20silhouettes%2C%20cream%20and%20terracotta%20color%20palette%2C%20soft%20cinematic%20daylight%2C%20elegant%20minimal%20composition%2C%20premium%20print%20aesthetic%2C%20subtle%20film%20grain%2C%20high%20detail&width=1600&height=1000&seq=pctg-hero-01&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85" />

      <div className="relative mx-auto flex w-full max-w-[1400px] flex-col items-center px-4 py-16 md:px-6 md:py-24">
        <span className="animate-fade-up inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-[11px] tracking-[0.28em] text-background-100 backdrop-blur-sm">
          <i className="ri-map-pin-add-line text-sm text-accent-300" />
          专题合集 · 现场实拍与直击
        </span>

        <h2
          className="animate-fade-up mt-7 text-center font-heading text-5xl font-black leading-none tracking-[0.08em] text-background-50 md:text-8xl"
          style={{ animationDelay: "0.08s" }}
        >
          私拍吃瓜
        </h2>

        <p
          className="animate-fade-up mt-6 max-w-2xl text-center text-sm leading-relaxed text-background-200 md:text-base"
          style={{ animationDelay: "0.16s" }}
        >
          首页直接看现场、实拍与直击内容，录制片段按时间分类。
          <span className="hidden sm:inline">想看现场完整记录、直击过程或保留原档，从下面的入口条进入即可。</span>
        </p>

        <div className="mt-10 w-full max-w-4xl" style={{ animationDelay: "0.24s" }}>
          <div className="animate-fade-up-slow flex items-center gap-3">
            <span className="h-px flex-1 bg-background-50/25" />
            <span className="text-[10px] tracking-[0.34em] text-background-300">快速入口</span>
            <span className="h-px flex-1 bg-background-50/25" />
          </div>

          <nav className="mt-5 grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-5">
            {quickEntries.map((entry) => (
              <a
                key={entry.label}
                href={entry.href}
                className="group flex cursor-pointer flex-col gap-3 rounded-lg border border-background-50/20 bg-background-50/10 p-4 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary-300/60 hover:bg-background-50/20"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${entry.icon} text-lg`} />
                </span>
                <span className="flex flex-col gap-1">
                  <span className="font-heading text-sm font-semibold text-background-50">
                    {entry.label}
                  </span>
                  <span className="text-[11px] text-background-300">{entry.hint}</span>
                </span>
              </a>
            ))}
          </nav>
        </div>

        <a
          href="#spotlight"
          className="animate-float mt-14 flex cursor-pointer items-center gap-2 text-[11px] tracking-[0.24em] text-background-300 transition-colors hover:text-background-50"
        >
          <i className="ri-arrow-down-line text-base" />
          向下看本期主打
        </a>
      </div>
    </section>
  );
}